const SCHEDULE_ACTION_VALUE = 'schedule';

export const shouldAutoOpenScheduler = (): boolean => {
  return new URLSearchParams(window.location.search).get('action') === SCHEDULE_ACTION_VALUE;
};
